<template>
  <div class="col-lg-8 offset-2">
    <div v-if="!done">
      <h1>Fill in the blanks</h1>
      <p>Directions: Fill in the template below. When you see a blank line, click on it and type the missing word or words. When you see a dropdown menu <select><option>like this</option></select>, click on it and then click the correct word.</p>
      <p>When you have filled in all of the blanks, click "I'm done" at the bottom. Highlight all of the text, copy it, and paste it somewhere safe.</p>
      <hr>

        <form @submit="finish" @change="saveText">
          <blanks :processed="processed"></blanks>
          <p class="text-center"><button class="btn btn-primary btn-lg" type="submit">I'm Done</button></p>
        </form>

    </div>
    <div v-if="done">
      <h1>Copy and Paste</h1>
      <p>Now that you're done, select all of the text below by clicking and dragging over all of it (you can also press control + a). Copy the text by pressing control+c and paste it somewhere safe by pressing control+v.</p>
      <hr>
      <p class="text-center"><button class="btn btn-primary btn-lg" @click="done=false">Continue typing</button></p>
      <textarea onclick="this.select()" class="finished" readonly>{{plainText}}</textarea>
    </div>
    <p class="text-center"><router-link class="btn btn-link btn-sm" :to="{name:'Edit',params:{inputText:$route.params.inputText}}">Teachers: click here to edit this template</router-link></p>
  </div>
</template>

<script>
  import {ConvertText} from "../Functions";

  const md5 = require('md5')
  const store = require('store')
  const expirePlugin = require('store/plugins/expire')
  store.addPlugin(expirePlugin)
export default {
  name: 'Fill',
  data () {
    return {
     processed: null,
      done:false
    }
  },
  computed:{
    plainText(){
      let text = "";
      if(this.processed!==null){
        this.processed.forEach((paragraph)=>{
          paragraph.forEach((chunk)=>{
            text+=chunk.value
          })
         text+="\n"
        })
      }
      return text
    },
    inputText(){
      return atob(this.$route.params.inputText)
    },
    docId(){
      return md5(this.$route.params.inputText)
    }
  },
  methods:{
    finish(e){
      e.preventDefault()
      this.done = true
    },
    saveText(){
      const duration = 1000 * 60 * 10  //10 minute duration

      store.set('template-'+this.docId, this.processed, new Date().getTime() + duration)
    },
    loadText(){
      store.removeExpiredKeys()
      let retrieve = store.get('template-'+this.docId)
      if(retrieve !== undefined){
        this.processed = retrieve
      }
    },
    processString(){
      this.processed = ConvertText(this.inputText)
    }

  },
  created: function(){
    this.processString()
    this.loadText()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Fill.vue